export const Cta = ({ }: {}) => {
    return (
        <>
            <section className="cta mt-14 lg:my-10 ">
                <div className="px-3 md:w-[95%] lg:px-0 max-w-7xl mx-auto" data-aos="zoom-in">
                    <div className="text-center">
                        <h3 className="text-white leading-9 lg:text-2xl uppercase text-3xl font-medium">Nos téléconseillers experts sont là pour vous aider à trouver l'opérateur qui vous correspond, sans engagement et sans frais de résiliation</h3>
                    </div>
                </div>
            </section>
        </>
    );
};
